import { useReferral } from '@/common/hooks/referrals/useReferral';
import { useOptionalRouteParam } from '@/common/hooks/useOptionalRouteParam';
import { useUserPermissionStates } from '@/common/hooks/useUserPermissionStates';

export const useReferralStateOverrides = () => {
  const referralId = useOptionalRouteParam('referralId');

  const { interaction } = useReferral(referralId);
  const transactingAgentId = interaction?.transactingAgent?.userId ?? undefined;
  const { submitAsStates } = useUserPermissionStates({
    userId: transactingAgentId,
  });

  if (!referralId) return undefined;

  return submitAsStates;
};
